import {AuthSource} from 'enums';
import {TRANSLATION_KEYS} from 'locale';
import {AccountPlanId} from 'types';

const T_KEYS = TRANSLATION_KEYS.COMMON;

export const AUTH_SOURCE_TRANSLATE = {
    [AuthSource.Salesforce]: T_KEYS.AUTH_SOURCE.SALESFORCE,
    [AuthSource.SalesforceWidget]: T_KEYS.AUTH_SOURCE.SALESFORCE_WIDGET,
    [AuthSource.Internal]: T_KEYS.AUTH_SOURCE.INTERNAL,
    [AuthSource.AndroidSDK]: T_KEYS.AUTH_SOURCE.ANDROID_SDK,
    [AuthSource.IosSDK]: T_KEYS.AUTH_SOURCE.IOS_SDK,
    [AuthSource.AppointmentsApplication]: T_KEYS.AUTH_SOURCE.APPOINTMENTS_APPLICATION,
    [AuthSource.OAuth]: T_KEYS.AUTH_SOURCE.OAUTH
};

export const AUTH_SOURCE_DESCRIPTION_TRANSLATE = {
    [AuthSource.Salesforce]: T_KEYS.AUTH_SOURCE_DESCRIPTION.SALESFORCE,
    [AuthSource.SalesforceWidget]: T_KEYS.AUTH_SOURCE_DESCRIPTION.SALESFORCE_WIDGET,
    [AuthSource.AndroidSDK]: T_KEYS.AUTH_SOURCE_DESCRIPTION.ANDROID_SDK,
    [AuthSource.IosSDK]: T_KEYS.AUTH_SOURCE_DESCRIPTION.IOS_SDK,
    [AuthSource.AppointmentsApplication]: T_KEYS.AUTH_SOURCE_DESCRIPTION.APPOINTMENTS_APPLICATION
};

export const ACCOUNT_PLAN_NAME_TRANSLATE = {
    [AccountPlanId.Free]: T_KEYS.PLAN_NAME.FREE,
    [AccountPlanId.Pro]: T_KEYS.PLAN_NAME.PRO,
    [AccountPlanId.Enterprise]: T_KEYS.PLAN_NAME.ENTERPRISE,
    [AccountPlanId.Custom]: T_KEYS.PLAN_NAME.CUSTOM
};
